import { Outlet } from "react-router-dom";

function SurveyLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default SurveyLayout;
